export default "__VITE_ASSET__DkkhSoGX__"